module.exports = __webpack_public_path__ + "static/media/IntroToVR.fbd13dae.png";